import { RouteRecordRaw } from 'vue-router';

import { useSystemSettingStore } from '@/store';

// 商品券関連
export const giftRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Gift',
    component: () => import('@/components/pages/gift/gift_business/index.vue'),
    path: '/gift_business',
    meta: {
      title: '商品券事業',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftDetail',
    component: () => import('@/components/pages/gift/gift/detail/index.vue'),
    path: '/gift/:id',
    meta: {
      title: 'デジタル商品券詳細',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftBusinessDetail',
    component: () => import('@/components/pages/gift/gift_business/detail/index.vue'),
    path: '/gift_business/:id',
    meta: {
      title: '商品券事業詳細',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftSalesManagementDetail',
    component: () => import('@/components/pages/gift/gift_sales_management/detail/index.vue'),
    path: '/gift_sales_management/:id',
    meta: {
      title: '販売管理詳細',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftSet',
    component: () => import('@/components/pages/gift/gift-set/index.vue'),
    path: '/gift-set',
    meta: {
      title: '商品券セット',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
  {
    name: 'GiftSetDetail',
    component: () => import('@/components/pages/gift/gift-set/detail/index.vue'),
    path: '/gift-set/:id',
    meta: {
      title: '商品券セット詳細',
      requiredAuthority: 'GIFTS',
    },
    beforeEnter: async (to, from, next) => {
      const useGiftFlg = useSystemSettingStore().systemSetting?.useGiftFlg;
      if (!useGiftFlg) {
        next({ name: 'NotFound' });
      } else {
        next();
      }
    },
  },
];
